import { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

function AuthContextProvider(props) {
  const storedToken = localStorage.getItem('userToken');
  const initialState = storedToken ? { ...jwtDecode(storedToken), token: storedToken } : null;

  const [token, setToken] = useState(initialState);
  const [currentUser, setCurrentUser] = useState({
    email: '',
    isAdmin: false,
    universityName: '',
    universitySlug: '',
  });

  const setUserLogout = () => {
    localStorage.removeItem('userToken');
    setToken(null);
    setCurrentUser(null);
  };

  useEffect(() => {
    const currentToken = localStorage.getItem('userToken');
    if (currentToken) {
      const decodedToken = jwtDecode(currentToken);
      if (decodedToken.exp * 1000 < Date.now()) {
        setUserLogout();
      } else {
        setToken(currentToken);
        setCurrentUser({
          email: decodedToken.email,
          isAdmin: decodedToken.isAdmin || false,
          universityName: decodedToken.universityName || '',
          universitySlug: decodedToken.universitySlug || '',
        });
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={{ token, currentUser, setUserLogout }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContextProvider;
